<template lang="pug">
  component(:is="component" :section="section")
    .alert Es ist ein Fehler aufgetreten
</template>

<script>
import LazyProductList from '@/extensions/shop/components/LazyProductList';
import SimpleProductList from '@/extensions/shop/components/SimpleProductList';

export default {
    name: 'ProductList',
    props: {
        section: {
            type: Object,
            required: true
        }
    },
    components: {
        LazyProductList,
        SimpleProductList
    },
    computed: {
        component() {
            let display = 'detailed'; // default
            let component = 'div';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'display');
                if (setting && setting.value !== undefined) display = setting.value;
            }

            switch (display) {
                case 'tile':
                case 'card':
                case 'row':
                    component = 'SimpleProductList';
                    break;

                default:
                case 'matrix':
                case 'preorder':
                case 'detailed':
                    component = 'LazyProductList';
                    break;
            }

            return component;
        }
    }
};
</script>

<style lang="sass"></style>
